import React from "react";
import {useLocaleContext} from "../../context/LocaleContext";

export default () => {
    const $locale = useLocaleContext();

    return (
        <section>
            <h3>{$locale.get('page.notFound.header')}</h3>
            <p>{$locale.get('page.notFound.description')}</p>
        </section>
    );
}
